import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthStateService } from './auth-state.service';
import { environment } from 'projects/environments/environment';
import { AcModel } from '../models/ac.model';
import { ApiService } from './api.service';
import { DataService } from './data.service';
import { Router } from '@angular/router';

export interface AcMainState {
  loading: boolean;
  error?: any;
  ac: AcModel;
}

@Injectable({
  providedIn: 'root'
})
export class AppService {

  public is404$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public version$: BehaviorSubject<string> = new BehaviorSubject(environment.version);
  public env$: BehaviorSubject<string> = new BehaviorSubject(null);
  public splashVisible$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private acModel: AcModel = null;
  private ac: BehaviorSubject<AcMainState | null> = new BehaviorSubject({
    loading: false,
    ac: this.acModel
  });
  public ac$ = this.ac.asObservable();

  public copyrightShown = false;
  public features: Array<string> = [];

  constructor(
    private auth: AuthStateService,
    private api: ApiService,
    private data: DataService,
    private router: Router,
  ) {
    this.acModel = this.data.ac;
    this.acModel.reload$.subscribe((reload: boolean) => {
      if (reload === true) {
        this.loadAc();
      }
    });
  }

  public set404(): void {
    this.auth.logout(false);
    this.is404$.next(true);
  }

  public setEnv(env: string): void {
    let version = environment.version;
    if (!env.match(/^prod.*/gim)) {
      version += ' ' + env;
    }
    this.version$.next(version);
    this.env$.next(env);
  }

  public setFeatures(features: Array<string>): void {
    this.features = features || [];
  }

  public hasFeature(feature: string): boolean {
    return this.features.includes(feature);
  }

  public loadAc(): void {
    this.ac.next({
      loading: true,
      ac: null
    });
    this.api.getAc().subscribe({
      next: (result: any) => {
        if (result.data) {
          const ac = this.acModel.deserialize(result.data);
          ac.authType = this.auth.isModerator() ? 'moderator' : this.auth.isObserver() ? 'observer' : 'candidate';
          this.ac.next({
            loading: false,
            ac
          });
          ac.mapAcStatus(true);
        }
      },
      error: (error: any) => {
        this.ac.next({
          loading: false,
          ac: null,
          error
        });
      }
    });
  }

  public redirectToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  public showSplashScreen(): void {
    this.splashVisible$.next(true);
  }

  public hideSplashScreen(): void {
    this.splashVisible$.next(false);
  }

  public setCopyRightShown(): void {
    this.copyrightShown = true;
  }

  public isCopyRightShown(): boolean {
    return this.copyrightShown;
  }

}
